export default function usePurchaseRequest() {
  const en = ['PENDING', 'DONE', 'OVERDUE', 'CANCELLED'];
  const th = ['รอสั่งซื้อ', 'เสร็จสิ้น', 'เกินกำหนด', 'ยกเลิก'];

  function translate(string: string, approved = true) {
    const index = en.indexOf(string);
    if (index === 3) return th[3];
    if (!approved) return 'รออนุมัติ';
    if (index > -1) return th[index];
    return '-';
  }

  const classMap = (type: string, approved = true) => {
    const index = en.indexOf(type);
    if (index === 3) return 'block text-white rounded-xl text-xs py-1 text-center bg-gray-400';
    if (!approved) return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
    switch (type) {
      case 'PENDING':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-500';
      case 'ARRIVED':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-700';
      case 'DONE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-600';
      case 'OVERDUE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-400';
      case 'CANCEL':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-gray-400';
      case 'CANCELLED':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-gray-400';
      case 'MATERIALS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-primary-600';
      case 'MISC':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-gray-600';
      case 'HEAT_TREATMENT':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
      case 'SURFACE_TREATMENT':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-600';
      case 'CLAIM':
        return 'block text-black rounded-xl text-xs py-1 text-center bg-yellow-300';
      default: return 'text-center';
    }
  };

  const typeEN = ['MATERIALS', 'MISC', 'HEAT_TREATMENT', 'SURFACE_TREATMENT', 'CLAIM'];
  const typeTH = ['ชิ้นส่วน', 'เบ็ดเตล็ด', 'ชุบแข็ง', 'ชุบผิว', 'ส่งเคลม'];
  function typeTranslate(string: string) {
    const index = typeEN.indexOf(string);
    if (index > -1) return typeTH[index];
    return '-';
  }

  return {
    en,
    th,
    classMap,
    translate,
    typeTranslate,
  };
}
